module.exports = __webpack_public_path__ + "static/media/002_3.f5865871.png";